import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { LoadingComponent } from 'app/components/loading/loading.component';
import { VelocidadeIdeal } from 'app/interfaces/Velocidade-ideal';
import { DialogService } from 'app/services/dialog/dialog.service';
import { VelocidadeIdealService } from 'app/services/velocidadeIdeal/velocidade-ideal.service';
import { finalize } from 'rxjs/operators';

function maximoMaiorQueMinimoValidator(): ValidatorFn {
  return (grupo) => {
    const minimo = grupo.get('fl_minimo')?.value;
    const maximo = grupo.get('fl_maximo')?.value;
    return minimo !== null && maximo !== null && maximo <= minimo ? { maximoMenorOuIgualAoMinimo: true } : null;
  };
}

@Component({
  selector: 'app-velocidade-ideal-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, LoadingComponent, TranslocoModule],
  templateUrl: './velocidade-ideal-form.component.html',
  styleUrl: './velocidade-ideal-form.component.css'
})
export class VelocidadeIdealFormComponent implements OnInit {
  public formulario!: FormGroup;
  public loading: boolean = true;
  public loadingBotao: boolean = false;
  public botaoDesabilitado: boolean = true;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly velocidadeIdealService: VelocidadeIdealService,
    private readonly dialogService: DialogService,
    private readonly translocoService: TranslocoService,
    private readonly router: Router
  ) { }

  ngOnInit(): void {
    this.construirForm();
    this.buscar();
    this.atualizarEstadoBotaoSubmit();
  }

  private construirForm(): void {
    this.formulario = this.formBuilder.group({
      fl_minimo: [null, [Validators.required, Validators.min(0)]],
      fl_maximo: [null, [Validators.required]],
      vc_cor_abaixo_minimo: [null, [Validators.required]],
      vc_cor_ideal: [null, [Validators.required]],
      vc_cor_acima_maximo: [null, [Validators.required]]
    }, { validators: maximoMaiorQueMinimoValidator() });
  }

  public buscar(): void {
    this.velocidadeIdealService.buscar()
      .pipe(finalize(() => (this.loading = false)))
      .subscribe(() => {
        this.formulario.patchValue(this.velocidadeIdealService.obterValorAtual());
      });
  }

  public atualizarEstadoBotaoSubmit(): void {
    this.formulario.valueChanges.subscribe(() => {
      this.botaoDesabilitado = !this.formulario.dirty || this.formulario.invalid;
    });
  }

  public salvar(): void {
    if (this.formulario.invalid) {
      return;
    }

    this.loadingBotao = true;

    this.velocidadeIdealService.salvar(this.formulario.value as VelocidadeIdeal)
      .pipe(finalize(() => (this.loadingBotao = false)))
      .subscribe({
        next: async () => {
          await this.dialogService.sucesso(
            this.translocoService.translate('COMPONENTS.VELOCIDADE_IDEAL.dialogs.successTitle'),
            this.translocoService.translate('COMPONENTS.VELOCIDADE_IDEAL.dialogs.successMessage')
          );
          this.router.navigate(['/premoplan']);
        },
        error: () => {
          this.dialogService.erro(
            this.translocoService.translate('COMPONENTS.VELOCIDADE_IDEAL.dialogs.errorTitle'),
            this.translocoService.translate('COMPONENTS.VELOCIDADE_IDEAL.dialogs.errorMessage')
          );
        }
      });
  }

  public cancelar(): void {
    this.router.navigate(['/premoplan']);
  }
}
